import { message } from 'ant-design-vue';

export const up = selectedId => effects => {
    const index = effects.indexOf(selectedId);
    if (index === effects.length - 1) {
        message.warn('已位于顶层');
        return effects;
    }
    return effects.slice(0, index).concat(
        effects[index + 1],
        selectedId,
        effects.slice(index + 2)
    );
};

export const down = selectedId => effects => {
    const index = effects.indexOf(selectedId);
    if (index <= 0) {
        message.warn('已位于底层');
        return effects;
    }
    return effects.slice(0, index - 1).concat(
        selectedId,
        effects[index - 1],
        effects.slice(index + 1)
    );
};

export const top = selectedId => effects => {
    const index = effects.indexOf(selectedId);
    if (index === effects.length - 1) {
        message.warn('已位于顶层');
        return effects;
    }
    return effects.slice(0, index).concat(
        effects.slice(index + 1),
        selectedId
    );
};

export const bottom = selectedId => effects => {
    const index = effects.indexOf(selectedId);
    if (index <= 0) {
        message.warn('已位于底层');
        return effects;
    }
    return [].concat(
        selectedId,
        effects.slice(0, index),
        effects.slice(index + 1)
    );
};

export const upMulti = ids => effects => {
    var lookup = {};
    ids.forEach(id => {
        lookup[id] = 1;
    });

    var copyIds = [].concat(effects), ret = [], last;
    copyIds.reverse(); // scan down
    copyIds.push(null);
    copyIds.forEach(id => {
        if (!id || !lookup[id]) {
            if (last) {
                ret.unshift(last);
            }
            last = id;
        } else {
            ret.unshift(id);
        }
    });

    return ret;
};

export const downMulti = ids => effects => {
    var lookup = {};
    ids.forEach(id => {
        lookup[id] = 1;
    });

    var copyIds = [].concat(effects), ret = [], last;
    copyIds.push(null);
    copyIds.forEach(id => {
        if (!id || !lookup[id]) {
            if (last) {
                ret.push(last);
            }
            last = id;
        } else {
            ret.push(id);
        }
    });

    return ret;
};

export const topMulti = ids => effects => {
    var lookup = {};
    ids.forEach(id => {
        lookup[id] = 1;
    });
    const used = [];
    const unused = effects.filter(id => {
        if (lookup[id]) {
            used.push(id);
            return false;
        }
        return true;
    });
    return [].concat(unused, used);
};

export const bottomMulti = ids => effects => {
    var lookup = {};
    ids.forEach(id => {
        lookup[id] = 1;
    });
    const used = [];
    const unused = effects.filter(id => {
        if (lookup[id]) {
            used.push(id);
            return false;
        }
        return true;
    });
    return [].concat(used, unused);
};